<template>
  <div
    v-if="questionGroup"
    class="
      flex flex-column
      justify-content-center
      tabs-question
      align-item-start
      w-full
    "
  >
    <img
      v-if="questionGroupImageUrl"
      class="tabs-question__image"
      :src="questionGroupImageUrl"
      alt="Картинка"
    />
    <div class="question-text">
      <p class="tabs-question__description">{{ questionGroup.text }}</p>
      <div v-if="questionGroup.questions" class="w-full">
        <div
          v-for="question in questionGroup.questions"
          :key="question.id"
          class="tabs-question__answer"
        >
          <p v-if="question.text" class="tabs-question__text">
            {{ question.text }}
          </p>
          <div
            class="
              tabs-question__btns
              flex
              justify-content-center
              align-item-center
            "
          >
            <div
                v-for="answer in question.answers"
                :key="answer.id"
                class="list-questions__radio-wrap flex"
            >
              <label :for="`answer_${question.id}_${answer.id}`">{{
                  answer.text
                }}</label>
              <input
                  :id="`answer_${question.id}_${answer.id}`"
                  :name="`answer_${question.id}`"
                  type="radio"
                  tabindex="1"
                  @change="setAnswer"
                  :value="answer.value"
                  :data-answer="answer.id"
                  :data-question="question.id"
                  :checked="savedAnswersMap[question.id] === answer.id"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { toRef } from "@vue/reactivity";
import CustomRadio from "@/components/Forms/Fields/CustomRadio.vue";
import {computed, watch} from "@vue/runtime-core";
import useAnswers from "@/mixins/useAnswers";
export default {
  components: { CustomRadio },
  name: "tabs-question-group",
  props: {
    questionGroup: {
      type: Object,
    },
    missedGroup: {
      type: Number,
      default: 0,
    },
    savedAnswers: {
      type: Array,
      default: () => [],
    },
    questionGroupImageUrl: {
      type: String,
      default: "",
    }
  },
  setup(props, context) {
    const group = toRef(props, "questionGroup");
    const missedGroup = toRef(props, "missedGroup");
    const { setAnswer, clearAnswers } = useAnswers(context);
    const text = [
      "Очень неэффективно",
      "Достаточно эффективно",
      "Нейтрально",
      "Достаточно эффективно",
      "Очень эффективно",
    ];

    const savedAnswersMap = computed(() => {
      const map = {};

      for (const item of props.savedAnswers) {
        map[item.question_id] = item.question_answer_id;
      }

      return map;
    });

    watch(group, () => {
      clearAnswers();
    });

    watch(missedGroup, () => {
      if (missedGroup.value === group.value.id) {
        clearAnswers();
      }
    });

    return {
      setAnswer,
      text,
      savedAnswersMap
    };
  },
};
</script>

<style lang="scss" scoped>
.tabs-question {
  white-space: nowrap;
  &__image {
    display: block;
    max-width: 600px;
    max-height: 300px;
    margin-bottom: 15px;
    border-radius: 4px;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: center;
  }

  &__answer {
    width: 100%;
    margin-top: 8px;
    padding: 16px;
    background-color: var(--light-grey);
    border-radius: 10px;
  }

  &__description {
    font-size: 16px;
    font-weight: 600;
    word-break: break-word;
    max-width: 100%;
    white-space: initial;
  }

  &__text {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    margin: 0 0 15px;
    white-space: break-spaces;
    word-break: break-word;
  }

  &__btns {
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 12px;
  }

  @media (max-width: 1100px) {
    &__btns > div {
      margin: 0;
    }
  }

  @media (max-width: $tablet-breakpoint) {
    &__answer {
      width: 100%;
    }

    &__description {
      font-size: 16px;
    }

    &__image {
      max-width: 90%;
    }
  }

  .question-text {
    max-width: 800px;
  }
}

.list-questions__radio-wrap {
    position: relative;
    flex: 1;
    flex-direction: row-reverse;
    column-gap: 8px;
    padding: 0;

    label {
      display: block;
      text-align: left;
      flex: 1 0;
      word-break: keep-all;
      font-size: 16px;
      padding: 0;
      white-space: break-spaces;
    }

    input {
      width: 16px;
      height: 16px;
      display: block;
      background-color: #fff;
      border: 1px solid var(--cream-color);
      border-radius: 50%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      cursor: pointer;
      margin: auto;
      position: relative;
      z-index: 2;
    }

    input:hover,
    input:focus {
      border-color: var(--main-green) !important;
    }

    input:checked {
      background-color: #fff !important;
      border: 1px solid var(--main-green) !important;
    }

    input:checked::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 8px;
      height: 8px;
      transform: translate(-50%, -50%);
      background: var(--main-green);
      border-radius: 50%;
    }
}
</style>
